import React from 'react';
import { Checkbox } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import styles from './PlanFitGroup.module.css';

/**
 * Um grupo do PlanFitModal (agendas, usuários, salas ou procedimentos): título,
 * contador "2 de 2", lista com checkbox e o que acontece com o que não ficar
 * marcado. Itens travados (responsável pela conta, quem está trocando) ficam.
 */
const PlanFitGroup = ({ title, instruction, hint, items, limit, selected, itemKey, disabled, onToggle }) => {
  const count = selected ? selected.size : 0;
  const full = count >= limit;
  const done = count === limit;

  return (
    <section className={styles.group}>
      <header className={styles.head}>
        <div className={styles.headText}>
          <span className={styles.title}>{title}</span>
          <span className={styles.instruction}>{instruction}</span>
        </div>
        <span className={`${styles.counter} ${done ? styles.counterDone : ''}`}>
          {count} de {limit}
        </span>
      </header>

      <ul className={styles.list}>
        {items.map((item) => {
          const key = itemKey(item);
          const checked = selected?.has(key) || false;
          const itemDisabled = item.locked || disabled || (!checked && full);
          return (
            <li
              key={key}
              className={[
                styles.item,
                checked ? styles.itemChecked : '',
                itemDisabled && !item.locked ? styles.itemDisabled : '',
              ].join(' ')}
              onClick={() => !itemDisabled && onToggle(item)}
            >
              <Checkbox
                size="small"
                checked={checked}
                disabled={itemDisabled}
                onChange={() => onToggle(item)}
                onClick={(e) => e.stopPropagation()}
                sx={{ padding: '2px', color: '#94A3B8', '&.Mui-checked': { color: 'var(--color-main, #5A80FB)' } }}
                inputProps={{ 'aria-label': item.label }}
              />
              <span className={styles.itemText}>
                <span className={styles.itemLabel}>{item.label}</span>
                {item.meta && <span className={styles.itemMeta}>{item.meta}</span>}
              </span>
              {item.locked && (
                <span className={styles.lockedTag}>
                  <LockOutlinedIcon fontSize="inherit" /> continua
                </span>
              )}
            </li>
          );
        })}
      </ul>

      <p className={styles.hint}>{hint}</p>
    </section>
  );
};

export default PlanFitGroup;
